import React from "react";

const DeepDiveCollapseHeader = function ({
    discoveredCategory,
    targetAudience,
    loading,
    children
}) {
    return (
        <div className="d-flex-col flex-1">
            <div className="d-flex gap-1 align-items-center">
                <span className="report--deepdivecollapse--label">Discovered Category: </span>
                <p className="report--deepdivecollapse--value flex-wrap d-flex align-items-center">
                    {loading ? "Loading..." : discoveredCategory}
                </p>
            </div>
            <div className="d-flex gap-1 align-items-center">
                <span className="report--deepdivecollapse--label">Target Audience: </span>
                <p className="report--deepdivecollapse--value flex-wrap d-flex align-items-center">
                    {loading ? "Loading..." : targetAudience}
                </p>
            </div>
            {children}
        </div>
    );
};

export default DeepDiveCollapseHeader;
